import { render, staticRenderFns } from "./BarConsultationsISTByLocalisationsDouleursOnlyMPAndTMS.vue?vue&type=template&id=85b3d1d0&"
import script from "./BarConsultationsISTByLocalisationsDouleursOnlyMPAndTMS.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByLocalisationsDouleursOnlyMPAndTMS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports